import React from "react";
import { useNavigate } from "react-router-dom";
import "./ProductDisplay.css";
import AddToCartButton from "./AddToCartButton";
import { FundraiserParticipantShop } from "../../Interfaces/FundraiserRole";
import { CartItem, generateUniqueId } from "../../Interfaces/Types";
import { useCart } from "../../contexts/Cart/CartContext";
import config from "../../config";
import { FileInstance } from "../../Interfaces/Product";

const ProductDisplay: React.FC<{
  file: FileInstance;
  participant: FundraiserParticipantShop;
}> = ({ file, participant }) => {
  const navigate = useNavigate();
  const { state } = useCart();
  const handleCustomizeClick = () => {
    const fundraiserID = participant.fundraiser
    if (file.file_type === "bottle") {
      state.fundraiser_participant = participant;
      navigate(
        `/storefront/customize-bottle?imageLocation=${file.file_location}&fundraiserID=${fundraiserID}`
      );
    }
    if (file.file_type === "clothing") {
      state.fundraiser_participant = participant;
      navigate(
        `/storefront/customize-clothing?imageLocation=${file.file_location}`
      );
    }
  };

  return (
    <div className="participant-shop-product-display">
      <img
        src={`${config.BACKEND_BASE_IMAGE_LOCATION}${file.file_location}` || ""}
        alt={file.file_name}
        className="participant-shop-product-display-image"
      />
      <div className="participant-shop-product-display-info">
        <p className="participant-shop-product-display-name">
          {file.file_name}
        </p>

        <button
          className="participant-shop-product-display-customize-button"
          onClick={handleCustomizeClick}
        >
          <span className="participant-shop-product-display-plus-icon">+</span>
          Customize Now
        </button>
      </div>
    </div>
  );
};

const FileDisplay: React.FC<{
  files: FileInstance[];
  participant: FundraiserParticipantShop;
}> = ({ files, participant }) => {
  return (
    <div className="products">
      {files.map((file, index) => (
        <ProductDisplay key={index} file={file!} participant={participant} />
      ))}
    </div>
  );
};

export default FileDisplay;
